import { all, call, put, takeEvery } from 'redux-saga/effects'
import FleetManagementApiService from './FleetManagementApiService'
import { GET_FLEET_PROCESSING_ITEM_STATUS_LIST } from 'Store/Component/FleetManagement/FleetManagementType'
import { setFleetProccessingItemStatusList } from 'Store/Component/FleetManagement/FleetManagementAction'
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getFleetProcessingItemStatusList(): any {
    try {

        let payloadData : IPayload= {
            apiType : apiType.FleetManagement,
            endpoint : `fleet/dropdown/itemstatus`,
            apiMethod :  apiMethod.GET,
            payload : null
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData            
        );
        if (response) {
            yield put(setFleetProccessingItemStatusList(response))
        }
    } catch (error) {
        yield put(setFleetProccessingItemStatusList([]))
    }
}

function* watchGetSaveAdminTask() {
    yield takeEvery(GET_FLEET_PROCESSING_ITEM_STATUS_LIST, getFleetProcessingItemStatusList)
}

export default function* combinedSaga() {
    yield all([
        watchGetSaveAdminTask()
    ])
}
